<template>
  <div>
    <div class="notify-actions-row">
      <button ref="notifyMeRef" :class="notifyClasses" @click="toggleNotifyMe">
        <span class="icon-bell"></span>
        <span>{{ notificationChecked ? 'Saved' : 'Notify Me' }}</span>
      </button>
      <HeartIcon :product="product" />
    </div>
    <NotifyMeModal
      :visible="notifyMeModalOpen"
      :product-id="product.product_id"
      @closed="notifyMeModalOpen = false"
    />
  </div>
</template>

<script>
import { requestedNotification } from '#common/utils/catalog'
import { baseURL } from '#common/utils/url'
import { useUserList } from '../../../composables/useUserList'

export default {
  components: {
    NotifyMeModal: defineAsyncComponent(
      () => import('#common/components/NotifyMe/NotifyMeModal'),
    ),
    HeartIcon: defineAsyncComponent(
      () => import('@/components/UserList/HeartIcon.vue'),
    ),
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notifyMeModalOpen: false,
    }
  },
  computed: {
    notificationChecked() {
      return requestedNotification(this.$auth.user, this.product.product_id)
    },
    notifyClasses() {
      return {
        'notify-me': true,
        checked: this.notificationChecked,
      }
    },
  },
  methods: {
    async toggleNotifyMe() {
      this.loading = true
      if (this.notificationChecked) {
        try {
          const referrer_route =
            baseURL() + this.$router.currentRoute.value.fullPath
          const response = await this.$axios.post(
            '/api/customer/toggle-product-subscription/',
            {
              product_id: this.product.product_id,
              referrer_url: referrer_route,
            },
          )
          useUserList().updateSubscription(this.$auth.user, response.data)
        } catch (e) {
          console.error('Error toggling product subscription', e)
        }
      } else {
        !this.$auth.loggedIn
          ? this.$auth.openAuthModal()
          : (this.notifyMeModalOpen = true)
      }
      // NOTE: somehow this button was not losing focus
      this.$refs.notifyMeRef.blur()
      this.loading = false
    },
  },
}
</script>
